<template>
  <v-container>
    <v-dialog v-model="addScheduleTime" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-row>
          <v-col>
            <v-btn
              right
              color="primary"
              class="mb-2"
              v-on="on"
              :disabled="disableSupervisorPrima()"
              @click="addedItem()"
              >{{$t('add_shift_code')}}</v-btn
            >
          </v-col>
          <v-col md="6 pt-0">
            <v-text-field
              :label="$t('find_shift_code')"
              prepend-inner-icon="mdi-magnify"
              single-line
              v-model="search"
              :rules="[validator.alfaNumberNotRequired]"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <v-form v-model="valid" ref="addForm">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2">{{$t('add_master_shift_code')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    :label="$t('shift_code')"
                    v-model="addItem.schedule_code"
                    :rules="[...rulesMaxChar, validator.alfaNumberNotRequired]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    :label="$t('description')"
                    v-model="addItem.description"
                    :rules="[...rules, validator.alfaNumberNotRequired]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-checkbox
                    v-model="checkbox"
                    :label="$t('dayoff')"
                    @change="changeRules"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    :label="$t('work_in')"
                    v-model="addItem.work_in"
                    type="time"
                    :rules="[...rulesHoliday, ...rulesMidnight]"
                    :disabled="disableInput"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    :label="$t('work_out')"
                    v-model="addItem.work_out"
                    type="time"
                    :rules="[...rulesHoliday, ...rulesMidnight]"
                    :disabled="disableInput"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    :label="$t('break_in')"
                    v-model="addItem.break_in"
                    type="time"
                    :disabled="disableInput"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    :label="$t('break_out')"
                    v-model="addItem.break_out"
                    type="time"
                    :disabled="disableInput"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
              <v-btn
                :loading="loading"
                color="primary"
                @click="addListTime(addItem)"
                :disabled="!valid"
                >{{$t('save')}}</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="editScheduleTime" max-width="500px">
      <v-card class="pt-3">
        <v-card-title>
          <span class="headline ml-2">{{$t('edit_master_shift_code')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  :label="$t('shift_code')"
                  v-model="editItem.schedule_code"
                  :rules="rulesMaxChar"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  :label="$t('description')"
                  v-model="editItem.description"
                  :rules="rules"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-checkbox
                  v-model="checkbox"
                  :label="$t('dayoff')"
                  @change="changeRules"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  :label="$t('work_in')"
                  v-model="editItem.work_in"
                  type="time"
                  :rules="[...rulesHoliday, ...rulesMidnight]"
                  :disabled="disableInput"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  :label="$t('work_out')"
                  v-model="editItem.work_out"
                  type="time"
                  :rules="[...rulesHoliday, ...rulesMidnight]"
                  :disabled="disableInput"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  :label="$t('break_in')"
                  v-model="editItem.break_in"
                  type="time"
                  :rules="[...rulesHoliday, ...rulesMidnight]"
                  :disabled="disableInput"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  :label="$t('break_out')"
                  v-model="editItem.break_out"
                  type="time"
                  :rules="[...rulesHoliday, ...rulesMidnight]"
                  :disabled="disableInput"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mx-6 pb-6">
          <v-row justify="center">
            <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
            <v-btn
              color="primary"
              :loading="loading"
              dark
              @click="editListTime(editItem)"
              >{{$t('save')}}</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteScheduleTime" persistent max-width="290">
      <v-card>
        <v-card-title class="headline"
          >{{$t('delete_this_shift_code')}}</v-card-title
        >
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteScheduleTime = false"
            >{{$t('cancel')}}</v-btn
          >
          <v-btn color="error" @click="deleteListTime(itemToDelete.id)"
            >{{$t('delete')}}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      :search="search"
      :items="time_master"
      :headers="checkSupervisor()"
      class="elevation-1 mt-3"
      :no-data-text="$t('no_data')"
      :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }"
    >
     <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
      <template v-slot:item.work_in="{ item }">
        {{ item.work_in | hour }}
      </template>
      <template v-slot:item.work_out="{ item }">
        {{ item.work_out | hour }}
      </template>
      <template v-slot:item.break_in="{ item }">
        {{ item.break_in | hour }}
      </template>
      <template v-slot:item.break_out="{ item }">
        {{ item.break_out | hour }}
      </template>
      <template v-slot:item.action="{ item }" v-if="!disableSupervisorPrima()">
        <span v-if="item.schedule_code != 'x' && item.schedule_code != 'X'">
          <v-icon small class="mr-2" v-if="!disableSupervisorPrima()" color="primary" @click="editedItem(item)"
            >mdi-pencil</v-icon
          >
          <v-icon small color="error" v-if="!disableSupervisorPrima()" @click="deleteItem(item)"
            >mdi-delete</v-icon
          >
        </span>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>

export default {
  name: "times",
  data() {
    return {
      headers: [
        { text: this.$i18n.t('shift_code'), value: "schedule_code" },
        { text: this.$i18n.t('description'), value: "description" },
        { text: this.$i18n.t('work_in'), value: "work_in" },
        { text: this.$i18n.t('work_out'), value: "work_out" },
        { text: this.$i18n.t('break_in'), value: "break_in" },
        { text: this.$i18n.t('break_out'), value: "break_out" },
        { text: this.$i18n.t('manage'), value: "action" },
      ],
      headersSupervisor: [
        { text: this.$i18n.t('shift_code'), value: "schedule_code" },
        { text: this.$i18n.t('description'), value: "description" },
        { text: this.$i18n.t('work_in'), value: "work_in" },
        { text: this.$i18n.t('work_out'), value: "work_out" },
        { text: this.$i18n.t('break_in'), value: "break_in" },
        { text: this.$i18n.t('break_out'), value: "break_out" },
      ],
      company_id: this.$store.state.company,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      time_master: [],
      addScheduleTime: false,
      editScheduleTime: false,
      deleteScheduleTime: false,
      addItem: {
        description: "",
        schedule_code: "",
        work_in: null,
        work_out: null,
        break_in: null,
        break_out: null,
        companyId: "",
      },
      editItem: {
        description: "",
        schedule_code: "",
        work_in: null,
        work_out: null,
        break_in: null,
        break_out: null,
        id: "",
      },
      itemToDelete: {
        id: "",
        description: "",
        companyId: "",
      },
      times: [
        {
          id: "",
          description: "",
          companyId: "",
        },
      ],
      get_id: [],
      search: "",
      editedIndex: -1,
      valid: true,
      rulesMidnight: [
          (v) => !!v || this.$i18n.t('field_required'),
          (v) => (v && v !== '00:00') || this.$i18n.t('please_use_different_time'),
        ],
      rules: [(v) => !!v || this.$i18n.t('field_required')],
      rulesMaxChar: [
        (v) => !!v || this.$i18n.t('field_required'),
        (v) => (v && v.length < 6) || this.$i18n.t('max_5'),
      ],
      loading: false,
      checkbox: false,
      rulesHoliday: [],
      disableInput: false,
    };
  },
  methods: {
    checkSupervisor(){
      if((this.$store.state.company == "prima-hotel" && this.$store.state.role) == 3 || (this.$store.state.company == "prima-hotel" && this.$store.state.role == 4)){
        return this.headersSupervisor
      }else{
        return this.headers
      }
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', {type, msg})
    },
    disableSupervisorPrima(){
      return (this.$store.state.company == "prima-hotel" && this.$store.state.role) == 3 || (this.$store.state.company == "prima-hotel" && this.$store.state.role == 4)
    },
    changeRules(data) {
      if (data == true) {
        this.rulesHoliday = [];
        this.disableInput = true;
        this.editItem.work_in = null;
        this.editItem.work_out = null;
        this.editItem.break_in = null;
        this.editItem.break_out = null;
        this.addItem.work_in = null;
        this.addItem.work_out = null;
        this.addItem.break_in = null;
        this.addItem.break_out = null;
      } else {
        this.rulesHoliday = this.rules;
        this.disableInput = false;
      }
    },
    addedItem() {
      this.addScheduleTime = true;
    },
    close() {
      this.addScheduleTime = false;
      this.alert = false;
      this.editScheduleTime = false;
      this.deleteScheduleTime = false;
    },
    editedItem(item) {
      this.editedIndex = this.times.indexOf(item);
      this.editItem = Object.assign({}, item);
      this.editScheduleTime = true;
      this.getListTime();
    },
    deleteItem(item) {
      this.itemToDelete = Object.assign({}, item);
      this.deleteScheduleTime = true;
    },
    async getListTime() {
      const result = await this.$store.dispatch('getScheduleShiftMasterByCompany', { companyId: this.company_id })
      this.times = result;
      this.time_master = result;
    },
    async addListTime(item) {
      this.loading = true;
      const body = {
        description: item.description,
        schedule_code: item.schedule_code,
        work_in: item.work_in,
        work_out: item.work_out,
        break_in: item.break_in,
        break_out: item.break_out,
        companyId: this.company_id,
        tolerance: 0
      }
      const result = await this.$store.dispatch('saveScheduleShiftV3', body)
      this.loading = false;
      if (result) {
        this.addScheduleTime = false;
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.getListTime();
      }
    },
    async editListTime(item) {
      this.loading = true;
      const body = {
        description: item.description,
        schedule_code: item.schedule_code,
        work_in: item.work_in,
        work_out: item.work_out,
        break_in: item.break_in,
        break_out: item.break_out,
        id: item.id,
        tolerance: 0
      }
      const result = await this.$store.dispatch('editScheduleShiftV3', body)
      this.loading = false;
      if (result) {
        this.editScheduleTime = false;
        this.showMessage('success', this.$i18n.t('alert_save'))
        this.getListTime();
      }
    },
    async deleteListTime(id) {
      const result = await this.$store.dispatch('deleteScheduleShiftV3', {id})
      if (result) {
        this.deleteScheduleTime = false;

        if (result.data.flag) {
          this.showMessage("success", result.message)
        } else {
          this.showMessage("warning", result.message)
        }
        this.getListTime();
      }
    },
  },
  created() {
    this.getListTime();
    this.changeRules(false);
  },
  watch: {
    addScheduleTime() {
      if (this.$refs.addForm) {
        this.$refs.addForm.reset();
      }
    },
  },
};
</script>
